/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Useremail1Inputs */

const en_entity_useremail1 = /** @type {(inputs: Entity_Useremail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Email`)
};

const de_entity_useremail1 = /** @type {(inputs: Entity_Useremail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

/**
* | output |
* | --- |
* | "User Email" |
*
* @param {Entity_Useremail1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_useremail1 = /** @type {((inputs?: Entity_Useremail1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Useremail1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_useremail1(inputs)
	return de_entity_useremail1(inputs)
});
export { entity_useremail1 as "entity_userEmail" }